import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import "./ContactUsStyle.scss";
import { contactUsTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import CustomInput from "../Common_UI_Kit/CustomInput";
import { submitContactUs } from "network/game.services";

const transformObject = (data) => {
  const country = data.country[0]?.value || ""
  const contactNumber = data.contactNumber 

  return {
    name: data.name,
    country,
    email: data.email,
    phone: contactNumber,
    message: data.message,
  }
}

const ContactUsSection = () => {
  const [selectedOptions, setSelectedOptions] = useState([
    {
      label: "local",
      value: "LO",
      flag: "",
      dialCode: '+0'
    },
  ])
  const [showSuccess, setShowSuccess] = useState(false)

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors }
  } = useForm()

  const country = useWatch({
    control,
    name: "country",
    defaultValue: selectedOptions,
  })

  const submitSuccess = () => {
    reset()
    setShowSuccess(true)
    const timeout = setTimeout(() => {
      setShowSuccess(false)
      clearTimeout(timeout)
    }, 3000)
  }

  const onSubmit = (data) => {
    submitContactUs(submitSuccess, transformObject(data))
  }

  useEffect(() => {
    if (country && country.length > 0) {
      const selectedCountry = country[0];
      setValue("contactNumber", `${selectedCountry.dialCode}`);
    }
  }, [country, setValue]);

  const countryOptions = contactUsTextContent.countries.map((country) => ({
    label: country.name,
    value: country.code,
    flag: country.flag,
    dialCode: country.dialCode
  }));

  return (
    <section className="contact-us-section">
      <div className="contact-us-wrap">
        <SectionHeading>{contactUsTextContent.headingText}</SectionHeading>

        <div className="contact-us-box">
          <div className="text-img-box">
            <div className="text-box">
              <p className="para-text">{contactUsTextContent.paraText}</p>
            </div>

            <div className="img-box">
              <img src={contactUsTextContent.imageSrc} alt="Image" />
            </div>
          </div>

          <div className="form-wrap">
            {showSuccess ? (
              <div className="contact-us-status-box">
                <div className="icon-box">
                  <img src={contactUsTextContent.imageSrcCheck} alt="Image" />
                </div>
                <h5 className="title-text">Thank you!</h5>
                <h6 className="subtitle-text">Your submission has been sent.</h6>
              </div>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)} className="form-box">
                <Controller
                  name="name"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Name is required" }}
                  render={({ field }) => (
                    <CustomInput
                      fieldType="textField"
                      type="text"
                      label="Your Name*"
                      placeholder="Enter Your Name"
                      errorText={errors.name?.message}
                      {...field}
                    />
                  )}
                />

                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  }}
                  render={({ field }) => (
                    <CustomInput
                      fieldType="textField"
                      type="email"
                      label="Email*"
                      placeholder="Enter Email Address"
                      errorText={errors.email?.message}
                      {...field}
                    />
                  )}
                />

                <Controller
                  name="country"
                  control={control}
                  defaultValue={selectedOptions}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <CustomInput
                      fieldType="selectField"
                      label="Country"
                      placeholder="Select Your Country"
                      options={countryOptions}
                      errorText={errors.country?.message}
                      selectedOptions={field.value}
                      onChange={(value) => {
                        setSelectedOptions(value);
                        field.onChange(value);
                      }}
                    />
                  )}
                />

                {/* Contact Number Field */}
                <Controller
                  name="contactNumber"
                  control={control}
                  defaultValue={selectedOptions[0].dialCode}
                  rules={{
                    required: "Contact Number is required",
                    pattern: {
                      value: /^[+]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
                      message: "Invalid contact number",
                    },
                  }}
                  render={({ field }) => (
                    <CustomInput
                      fieldType="textField"
                      type="text"
                      label="Contact Number*"
                      placeholder="Enter Contact Number"
                      startIcon={selectedOptions[0]?.flag ? <img src={selectedOptions[0]?.flag} alt="Flag" /> :<></>}
                      startIconClass="flag-img"
                      errorText={errors.contactNumber?.message}
                      {...field}
                    />
                  )}
                />

                <Controller
                  name="message"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Message is required" }}
                  render={({ field }) => (
                    <CustomInput
                      fieldType="textAreaField"
                      type="text"
                      label="Message*"
                      placeholder="Your Message"
                      errorText={errors.message?.message}
                      {...field}
                    />
                  )
                  }
                />

                <div className="btn-box">
                  <CustomButton type="submit" buttonType="grey" label={contactUsTextContent.btnText} />
                </div>
              </form>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;
